module.exports = __webpack_public_path__ + "img/ic24Lock.c578fff9.svg";